import { render, staticRenderFns } from "./wageBillsPage.vue?vue&type=template&id=6ac5f92c&scoped=true&"
import script from "./wageBillsPage.vue?vue&type=script&lang=js&"
export * from "./wageBillsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5f92c",
  null
  
)

export default component.exports